export default {
  COUNTRY_CODE: 'MX',
  ID: 'es-mx',
  NUMBER_FORMAT: {
    CURRENCY_DESCRIPTION: 'Peso mejicano',
    CURRENCY_SYMBOL: '$',
    DECIMAL_SEPARATOR: '.',
    GROUP_SEPARATOR: ',',
  },
};
